export default "__VITE_ASSET__DNxc9DH7__"